import './index.scss'
import '../../assets/scripts/jquery.waypoints.min.js'
import '../../assets/scripts/jquery.countup.min.js'
import Swiper from 'swiper/dist/js/swiper.min.js'

!(function(){
  if($(window).width() > 767){
    $('.section2 ul li').eq(0).addClass('active')
    $('.section2 ul li').eq(0).find('.item-desc').slideDown()
  }
  $('.section4 .swiper-tab div').eq(0).addClass('active')
})()

$('.ny-banner .nav-list a').on('click',function(){
  if($(window).width() < 992){
    $('.ny-banner .mob-active-nav').removeClass('active')
    $('.ny-banner .nav-list').slideUp()
  }
})

$('.counter').countUp();

var mouseover_tid = [];
var mouseout_tid = [];
$(document).ready(function () {
  $(".section2 ul li").each(function (index) {
    if($(window).width() > 767){
      $(this).hover(
        // 鼠标进入
        function () {
          var _self = this;
          // 停止卷起事件
          clearTimeout(mouseout_tid[ index ]);
          // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
          mouseover_tid[ index ] = setTimeout(function () {
            $(_self).addClass('active').siblings().removeClass('active');
            $(_self).find('.item-desc').slideDown()
            $(_self).siblings().find('.item-desc').slideUp()
          }, 101);
        },
        // 鼠标离开
        function () {
          var _self = this;
          // 停止展开事件
          clearTimeout(mouseover_tid[ index ]);
          // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
          mouseout_tid[ index ] = setTimeout(function () {
  
          }, 101);
        });
      }
    });
});


$('.section4 .swiper-tab div').hover(function(){
  let index = $(this).index()
  $(this).addClass('active').siblings().removeClass('active')
  swiper1.slideTo(index)
})
var swiper1 = new Swiper(".tabSwiper", {
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  allowTouchMove: false,
});
var swiper2 = new Swiper(".rongyuSwiper", {
  slidesPerView: 3,
  spaceBetween: 90,
  navigation: {
    nextEl: ".rongyuSwiper .swiper-button-next",
    prevEl: ".rongyuSwiper .swiper-button-prev",
  },
  breakpoints: {
    1366: { 
      slidesPerView: 3,
      spaceBetween: 60,
    },
    1024: { 
      slidesPerView: 3,
      spaceBetween: 30,
    },
    768: { 
      slidesPerView: 2.2,
      spaceBetween: 30,
    },
    767: { 
      slidesPerView: 1.1,
      spaceBetween: 30,
    },
  } 
});
var swiper3 = new Swiper(".zizhiSwiper", {
  slidesPerView: 3,
  spaceBetween: 90,
  navigation: {
    nextEl: ".zizhiSwiper .swiper-button-next",
    prevEl: ".zizhiSwiper .swiper-button-prev",
  },
  breakpoints: {
    1366: { 
      slidesPerView: 3,
      spaceBetween: 60,
    },
    1024: { 
      slidesPerView: 3,
      spaceBetween: 30,
    },
    768: { 
      slidesPerView: 2.2,
      spaceBetween: 30,
    },
    767: { 
      slidesPerView: 1.1,
      spaceBetween: 30,
    },
  }
});